// composables/fetch.ts
import type { NitroFetchRequest } from 'nitropack'
import type { RequestResponse } from '@/types/publicType'
import { useLanguageStore } from '@/stores/language'
import qs from 'qs'
import cryptojs from '@/utils/cryptojs'
interface Params {
  url: NitroFetchRequest
  data?: Record<string, any>
  params?: Record<string, any>
  method?: 'GET' | 'POST'
  loading?: boolean
  isFormData?: boolean
  isCloseTost?: boolean //是否关闭提示
}

let needLoadingRequestCount = 0

export async function getFetchData<T = RequestResponse<any>>({
  url,
  data,
  params,
  method = 'GET',
  loading = false,
  isFormData = false,
  isCloseTost = false
}: Params): Promise<T> {
  return new Promise((resolve, reject) => {
    const runtimeConfig = useRuntimeConfig()

    $fetch(url, {
      method,
      baseURL:
        runtimeConfig.public.appMode === 'development'
          ? '/api'
          : runtimeConfig.public.apiUrl,
      headers: {
        Platform: 'web'
      },
      // onRequest相当于请求拦截
      onRequest({ options }) {
        // 需要转菊花时，loading传true
        if (loading) {
          if (needLoadingRequestCount === 0) {
            showLoadingToast({
              message: '',
              forbidClick: true,
              duration: 0
            })
          }
          needLoadingRequestCount++
        }

        // 设置请求参数
        if (isFormData) {
          options.body = data
        } else {
          const uid = localStorage.getItem('loginInfo')
            ? JSON.parse(localStorage.getItem('loginInfo') as string).uid
            : 0
          const languageStore = useLanguageStore() // 此字段不限制于接口，所以可以直接使用

          // 请求参数
          const requestData = {
            uid,
            ticket: localStorage.getItem('ticket'),
            language: languageStore.languageInfo.value,
            app: 'web',
            t: new Date().getTime(),
            ...data,
            ...params
          }
          console.log(`request => ${method}: ${url}\n`, requestData)

          if (
            runtimeConfig.public.appMode === 'production' ||
            runtimeConfig.public.appMode === 'release'
          ) {
            // 线上环境才加密和防篡改
            // 请求参数排序操作
            const requestDataKey = Object.keys(requestData) // 取key数组
            requestDataKey.sort() // 数组排序
            const requestDataSort = {}
            for (const key of requestDataKey) {
              requestDataSort[key] = requestData[key]
            }

            // 防篡改签名
            const sn = cryptojs.tamperProofSign(
              qs.stringify(requestDataSort, { encode: false })
            )

            // 加密
            const ed = cryptojs.encryptAES(
              qs.stringify({ ...requestDataSort, sn }, { encode: false })
            )

            if (method === 'POST') {
              // 设置请求头
              options.headers = {
                ...options.headers,
                'Content-Type': 'application/x-www-form-urlencoded'
              }
              options.body = qs.stringify({ ed })
            } else {
              options.query = { ed }
            }
          } else {
            // 线下不用加密和防篡改
            if (method === 'POST') {
              // 设置请求头
              options.headers = {
                ...options.headers,
                'Content-Type': 'application/x-www-form-urlencoded'
              }
              options.body = qs.stringify({ ...requestData, sn: '123456' })
            } else {
              options.query = { ...requestData, sn: '123456' }
            }
          }
        }
      },
      // onResponse相当于响应拦截
      onResponse({ response }) {
        if (loading) {
          needLoadingRequestCount--
          if (needLoadingRequestCount <= 0) {
            closeToast()
          }
        }
        // 有ed才需要解密
        if (response._data.ed) {
          response._data = JSON.parse(cryptojs.decryptAES(response._data.ed))
        }
        console.log(`response => ${method}: ${url}\n`, response._data)
        // 未设置状态码则默认成功状态
        const code = response._data.code || 200
        // 获取错误信息
        const message = response._data.message
        const publicStore = usePublicStore()
        if (code === 401 && !publicStore.isIOSWebView) {
          publicStore.resetLogin({ msg: '接口API-401', type: 'api' })
        }
        if (code !== 200 && !isCloseTost) {
          showToast(message)
        }
      },
      onRequestError({ error }) {
        // 处理请求错误
        console.warn('[onRequestError]', error)
      },
      onResponseError({ response }) {
        // 处理响应错误
        console.warn('[onResponseError]', response)
      }
    })
      .then((res) => {
        // console.log('请求响应', res)
        resolve(res as T)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
